import classNames from "classnames";
import React from "react";

import ArrowDown from "./svg/ArrowDown.svg?react";
import Button from "./svg/Button.svg?react";
import ChannelTalkDay from "./svg/ChannelTalkDay.svg?react";
import ChannelTalkNight from "./svg/ChannelTalkNight.svg?react";
import Close from "./svg/Close.svg?react";
import Filter from "./svg/Filter.svg?react";
import GridLarge from "./svg/GridLarge.svg?react";
import GridSmall from "./svg/GridSmall.svg?react";
import LeftArrow from "./svg/LeftArrow.svg?react";
import Logo1 from "./svg/Logo1.svg?react";
import Logo2 from "./svg/Logo2.svg?react";
import Logo3 from "./svg/Logo3.svg?react";
import Menu from "./svg/Menu.svg?react";
import Refresh from "./svg/Refresh.svg?react";
import RightArrow from "./svg/RightArrow.svg?react";
import Select from "./svg/Select.svg?react";
import SelectBorder from "./svg/SelectBorder.svg?react";
import ZoomIn from "./svg/ZoomIn.svg?react";
import ZoomOut from "./svg/ZoomOut.svg?react";
import BarM1 from "./svg/bar-1-m.svg?react";
import Bar1 from "./svg/bar-1.svg?react";
import BarM2 from "./svg/bar-2-m.svg?react";
import Bar2 from "./svg/bar-2.svg?react";
import BarM3 from "./svg/bar-3-m.svg?react";
import Bar3 from "./svg/bar-3.svg?react";
import TNTDJ from "./svg/tnt-dj.svg?react";

type TSvgIcon = React.FunctionComponent<React.SVGProps<SVGSVGElement>> & { title?: string | undefined };

export const iconMap = {
  Select: Select as TSvgIcon,
  ZoomIn: ZoomIn as TSvgIcon,
  ZoomOut: ZoomOut as TSvgIcon,
  ChannelTalkDay: ChannelTalkDay as TSvgIcon,
  ChannelTalkNight: ChannelTalkNight as TSvgIcon,
  Bar1: Bar1 as TSvgIcon,
  Bar2: Bar2 as TSvgIcon,
  Bar3: Bar3 as TSvgIcon,
  BarM1: BarM1 as TSvgIcon,
  BarM2: BarM2 as TSvgIcon,
  BarM3: BarM3 as TSvgIcon,
  SelectBorder: SelectBorder as TSvgIcon,
  Button: Button as TSvgIcon,
  Logo1: Logo1 as TSvgIcon,
  Logo2: Logo2 as TSvgIcon,
  Logo3: Logo3 as TSvgIcon,
  TNTDJ: TNTDJ as TSvgIcon,
  Menu: Menu as TSvgIcon,
  Close: Close as TSvgIcon,
  LeftArrow: LeftArrow as TSvgIcon,
  RightArrow: RightArrow as TSvgIcon,
  Refresh: Refresh as TSvgIcon,
  ArrowDown: ArrowDown as TSvgIcon,
  GridSmall: GridSmall as TSvgIcon,
  GridLarge: GridLarge as TSvgIcon,
  Filter: Filter as TSvgIcon,
};

interface IProps {
  name: keyof typeof iconMap;
  width?: string;
  height?: string;
  alt?: string;
  className?: string | classNames.ArgumentArray;
}

function Icon({ name, width = "20px", height = "20px", alt, className }: IProps) {
  const SVGLogo = iconMap[name];

  return (
    <>
      {alt ? <span className="sr-only">{alt}</span> : null}
      <SVGLogo className={classNames(className)} height={height} width={width} />
    </>
  );
}

export default Icon;
